import { createAction } from 'redux-actions';

import {
	BILLING_PERIODS_FETCH,
	BILLING_PERIODS_RECEIVE,
	SET_ACTIVE_BILLING_PERIOD,
	INVOICES_INITIALIZE,
	INVOICES_FETCH,
	INVOICES_RECEIVE,
	INVOICES_RESET,
	SET_DEFAULT_PAYMENT_METHOD,
	SET_DEFAULT_PAYMENT_METHOD_FINISHED,
	FETCH_ZUORA_SIGNATURE,
	RECEIVE_ZUORA_SIGNATURE
} from './constants';

export const fetchBillingPeriods = createAction(BILLING_PERIODS_FETCH, (id) => ({
	id
}));

export const receiveBillingPeriods = createAction(BILLING_PERIODS_RECEIVE, (data) => ({
	data
}));

export const setActiveBillingPeriod = createAction(SET_ACTIVE_BILLING_PERIOD, (billingPeriod) => ({
	billingPeriod
}));

export const initializeInvoices = createAction(INVOICES_INITIALIZE, (id) => ({
	id
}));

export const fetchInvoices = createAction(INVOICES_FETCH, (id, fromBillingPeriodId, amount) => ({
	id,
	fromBillingPeriodId,
	amount
}));

export const receiveInvoices = createAction(INVOICES_RECEIVE);

export const resetInvoices = createAction(INVOICES_RESET);

export const fetchZuoraSignature = createAction(FETCH_ZUORA_SIGNATURE, (pageId, zuoraUrl) => ({
	pageId,
	zuoraUrl
}));

export const receiveZuoraSignature = createAction(RECEIVE_ZUORA_SIGNATURE, (signatureObject) => ({
	signatureObject
}));

export const setDefaultPaymentMethod = createAction(SET_DEFAULT_PAYMENT_METHOD, (accountId, paymentMethodId) => ({
	accountId,
	paymentMethodId
}));

export const setDefaultPaymentMethodFinished = createAction(SET_DEFAULT_PAYMENT_METHOD_FINISHED);
